import { gql } from '@apollo/client';

export const CHAT_WITH_REACT_BOT = gql`
  mutation ChatWithReActBot($params: ChatWithReActBotInput!) {
    chatWithReActBot(params: $params) {
      success
      message
      errors
      data {
        chatId
        botResponse {
          message
          inputType
          options
          searchEnabled
          canRestart
          currentStep
        }
      }
    }
  }
`;

export const DELETE_REACT_CHAT = gql`
  mutation DeleteChatbotChat($params: DeleteChatbotChatInput!) {
    deleteChatbotChat(params: $params) {
      success
      message
      errors
    }
  }
`;
